import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Address } from '../../_models/address';

@Component({
  standalone: false,
  selector: 'app-address',
  templateUrl: './address.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./address.component.css']
})
export class AddressComponent {

  @Input() address: Address = new Address();

}
